/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyInputType from './survey-input-type';
import SurveyInputTypeDetail from './survey-input-type-detail';
import SurveyInputTypeUpdate from './survey-input-type-update';
import SurveyInputTypeDeleteDialog from './survey-input-type-delete-dialog';

const SurveyInputTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyInputType />} />
    <Route path="new" element={<SurveyInputTypeUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyInputTypeDetail />} />
      <Route path="edit" element={<SurveyInputTypeUpdate />} />
      <Route path="delete" element={<SurveyInputTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyInputTypeRoutes;
